import React from 'react';
import PropTypes from 'prop-types';

const InfoContent = ({ children }) => (
  <div className="info__content">{children}</div>
);

InfoContent.propTypes = {
  children: PropTypes.node
};

InfoContent.defaultProps = {
  children: null
};

const InfoTitle = ({ children }) => <h6 className="info__title">{children}</h6>;

InfoTitle.propTypes = {
  children: PropTypes.node
};

InfoTitle.defaultProps = {
  children: null
};

const Info = ({ children, clear }) => (
  <div className={`info${clear ? ' info--clear' : ''}`}>{children}</div>
);

Info.Title = InfoTitle;
Info.Content = InfoContent;

Info.propTypes = {
  children: PropTypes.node,
  clear: PropTypes.bool
};

Info.defaultProps = {
  children: null,
  clear: false
};

export default Info;



// WEBPACK FOOTER //
// ./src/components/Common/Info/Info.js